import axios from 'axios';
import errorHandler from 'common/errorHandler';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from './actions';
import { getProxyUrl } from 'VideoPlayback/Utils';

function* getRecordingData(api, recordingInputUrl) {
  let result = yield call([axios, axios.get], recordingInputUrl, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return result.data;
}

export function* getRecordingDataRequest(api, { recordingInputUrl }) {
  try {
    let response = yield call(getRecordingData, api, recordingInputUrl);
    let recordingData = response.data;
    for (let scene of recordingData.scenes) {
      let background = scene.background;
      for (let src of background.src) {
        try {
          if (src.url && src.type === 'image') {
            let resourceDownloadUrl = getProxyUrl(src.url);
            const blobResponse = yield call([axios, axios.get], resourceDownloadUrl, { responseType: 'blob' });
            if (blobResponse.status === 200 && blobResponse.data && blobResponse.data.size) {
              src.url = URL.createObjectURL(blobResponse.data);
            }
          }
        } catch {}
      }
    }
    yield put(actions.getRecordingDataSuccess(recordingData));
  } catch (error) {
    window.recordingError = `GET_RECORDING_DATA_REQUEST_ERROR - ${error.message}`;
    console.log('getRecordingDataRequest_error');
    let errorObject = errorHandler(error, 'Get', 'Recording data');
    yield put(actions.getRecordingDataFailure(errorObject));
  }
}

export function* loadRecordingImagesRequest(api, { recordingData }) {
  try {
    if (recordingData.scenes) {
      for (let scene of recordingData.scenes) {
        let background = scene.background;
        for (let src of background.src) {
          if (src.url && src.type === 'image') {
            try {
              let resourceDownloadUrl = getProxyUrl(src.url);
              const blobResponse = yield call([axios, axios.get], resourceDownloadUrl, { responseType: 'blob' });
              if (blobResponse.status === 200 && blobResponse.data && blobResponse.data.size) {
                src.url = URL.createObjectURL(blobResponse.data);
              }
            } catch {}
          }
        }
        if (scene.sub_scenes && scene.sub_scenes.length > 0) {
          for (let subScene of scene.sub_scenes) {
            if (subScene.displayItems && subScene.displayItems.length > 0) {
              for (let displayItem of subScene.displayItems) {
                if (displayItem.type === 'visual' && displayItem.visualType === 'image' && displayItem.src && displayItem.src.startsWith('http')) {
                  try {
                    let resourceDownloadUrl = getProxyUrl(displayItem.src);
                    const blobResponse = yield call([axios, axios.get], resourceDownloadUrl, { responseType: 'blob' });
                    if (blobResponse.status === 200 && blobResponse.data && blobResponse.data.size) {
                      displayItem.src = URL.createObjectURL(blobResponse.data);
                    }
                  } catch {}
                }
              }
            }
          }
        }
      }
    }
    yield put(actions.getRecordingDataSuccess(recordingData));
  } catch (error) {
    yield put(actions.getRecordingDataSuccess(recordingData));
  }
}

export function* watchGetRecordingDataRequest(api, { params }) {
  yield call(getRecordingDataRequest, api, params);
}

export function* watchLoadRecordingImagesRequest(api, { params }) {
  yield call(loadRecordingImagesRequest, api, params);
}

function* watcher({ api }) {
  yield takeLatest(actions.GET_RECORDING_DATA_REQUEST, watchGetRecordingDataRequest, api);
  yield takeLatest(actions.LOAD_RECORDING_IMAGES_REQUEST, watchLoadRecordingImagesRequest, api);
}

export default watcher;
